import React, {useMemo} from "react";
import {
    ResponsiveContainer,
    Scatter,
    ScatterChart,
    XAxis,
    YAxis,
} from "recharts";

export default function SkeletonScatterChart() {
    const data = useMemo(() => {
        const result = [];
        for (let i = 0; i < 25; i++) {
            result.push({
                name: `Label ${i + 1}`,
                value: Math.floor(Math.random() * 1000),
            });
        }
        return result;
    }, []);

    return (
        <ResponsiveContainer height="100%">
            <ScatterChart data={data}>
                <XAxis dataKey="name" tick={false} height={1} />
                <YAxis tick={false} width={1} />
                <Scatter
                    dataKey={"value"}
                    isAnimationActive={false}
                    className="skeleton-svg"
                />
            </ScatterChart>
        </ResponsiveContainer>
    );
}
